import styled from 'styled-components';

export const IpsativeQuestionnaireMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const IpsativeSliderWrapper = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const IpsativeProgressWrapper = styled.div`
  margin-bottom: 25px;
  padding: 16px 20px;
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
`;
